import { Stack, Text } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Contract } from "../../../DeliveryOverview.types";

const automaticExtensionFilterOptions = [
  { value: "true", label: "Ja" },
  { value: "false", label: "Nein" }
];

export function getAutomaticExtensionColumn(): MRT_ColumnDef<Contract> {
  return {
    accessorKey: "automatic_extension",
    header: "Automatische Verlängerung",
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: automaticExtensionFilterOptions
    },
    size: 170,
    filterFn: (row, _, filterValue) => {
      const automaticExtensionValue = String(row.original.automatic_extension);
      return (
        filterValue.length === 0 ||
        filterValue.length == 2 ||
        filterValue.includes(automaticExtensionValue)
      );
    },
    Cell: ({ renderedCellValue, row }) => (
      <Stack gap="xs">
        {renderedCellValue ? "Ja" : "Nein"}
        {renderedCellValue && (
          <Text c="neutral" fz="xs">
            {row.original.extension_count}× verlängert
          </Text>
        )}
      </Stack>
    )
  };
}
